import { ApplicationActivity } from "../types";
import { getFullName } from "shared/utils/get-full-name";

export const WarningsReportOverride = ({
  activityItem
}: {
  activityItem: ApplicationActivity;
}) => {
  return (
    <div>
      <p className="text-base font-bold text-content-1000">
        Failed warnings report was overridden for{" "}
        <span className="font-normal">
          {getFullName({
            firstName: activityItem.details.contact?.first_name || "",
            lastName: activityItem.details.contact?.last_name || "",
            middleName: activityItem.details.contact?.middle_name,
            short: true
          })}
        </span>
      </p>
      {activityItem.details.reason && (
        <p className="text-sm font-normal text-content-400">
          Reason: {activityItem.details.reason}
        </p>
      )}
    </div>
  );
};
